
import domready from '../utils/domready.js';
import 'intersection-observer';
  domready(function () {
    var inpageNav = document.querySelector('.navigation--inpage')
    if (!inpageNav) {
      return
    }

    var stickyNav = inpageNav.cloneNode(true)
    var sectionLinks = Array.prototype.slice.call(stickyNav.querySelectorAll('a'))
    var inpageLinks = []
    var stickyLinks = []
    var ratios = {}

    stickyNav.hidden = true
    stickyNav.classList.add('navigation--sticky')
    inpageNav.parentNode.insertBefore(stickyNav, inpageNav.nextElementSibling)

    function determineActiveLink () {
      var activeLink = null;
      var biggestIntersection = 0;
      stickyLinks.forEach(function (link) {
        var intersection = ratios[link.targetId];
        if (!activeLink || biggestIntersection < intersection) {
          activeLink = link;
          biggestIntersection = intersection;
        }
      });
      if (biggestIntersection < 0.2) {
        activeLink = null;
      }
      stickyLinks.forEach(function (stickyLink) {
        if (stickyLink === activeLink) {
          stickyLink.classList.add('is-active')
        } else {
          stickyLink.classList.remove('is-active')
        }
      })
      inpageLinks.forEach(function (inpageLink) {
        if (activeLink && inpageLink.targetId === activeLink.targetId) {
          inpageLink.classList.add('is-active')
        } else {
          inpageLink.classList.remove('is-active')
        }

        inpageLink.addEventListener('click', function(e) {
            e.preventDefault();
            var targetToScroll = e.target.getAttribute('href');
            document.querySelector(targetToScroll).scrollIntoView({behavior: "smooth"});
        });
      });
    }

    var sectionObserver = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          ratios[entry.target.id] = entry.intersectionRatio;
        });
        determineActiveLink();
      }, {
        threshold: [.01, .5, 1]
      }
    );

    sectionLinks.forEach(function (stickyLink) {
      var target = stickyLink.href.split('#');
      if (target.length !== 2) {
        return
      }
      var inpageLink = inpageNav.querySelector('[href$="#' + target[1] + '"]');
      var section = document.getElementById(target[1])
      if (section) {
        inpageLink.section = stickyLink.section = section
        inpageLink.targetId = stickyLink.targetId = section.id;
        ratios[section.id] = 0;
        sectionObserver.observe(section);
        inpageLinks.push(inpageLink)
        stickyLinks.push(stickyLink)
      } else {
        stickyLink.parentNode.hidden = true
        inpageLink.parentNode.hidden = true
      }
        stickyLink.addEventListener('click', function(e) {
            e.preventDefault();
            var targetToScroll = e.target.getAttribute('href');
            document.querySelector(targetToScroll).scrollIntoView({behavior: "smooth"});
        });
    })

    var stickynavObserver = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          stickyNav.hidden = entry.intersectionRatio === 1;
        });
      }, {
        rootMargin: '1px 0px 0px 0px',
        threshold: [.00001, 1]
      }
    );
    stickynavObserver.observe(inpageNav);
  })
